import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';
import { CatalogosSatService } from '../../../../services/catalogos-sat-service';

declare var $;

@Component({
  selector: 'app-formulario-contrato',
  templateUrl: './formulario-contrato.component.html',
  styleUrls: ['./formulario-contrato.component.scss']
})
export class FormularioContratoComponent implements OnInit {

    @Input() public contrato = null;
    @Output() contratoGuardado: EventEmitter<any> = new EventEmitter;

    /** Un contrato que todavia no se guarda: no trae id. */
    public get esContratoNuevo(): boolean {
        return !(this.contrato && this.contrato.id_contrato);
    }

    /**
     * Un contrato nuevo no puede arrancar en un mes ya cerrado: el sistema generaria los cargos
     * de esos meses, que normalmente ya se facturaron aparte, y el cobro quedaria duplicado.
     * Se deja todo el mes en curso, que es como se capturan casi siempre (unos dias despues de
     * que arrancan). Al editar un contrato ya guardado no se limita.
     */
    public get minFechaInicio(): string {
        if (!this.esContratoNuevo) {
            return null;
        }

        const hoy = new Date();
        return hoy.getFullYear() + '-' + ('0' + (hoy.getMonth() + 1)).slice(-2) + '-01';
    }

    public proveedor_buscado:boolean = false;

    public errors: any = {
      proveedor: {},
      obligado_solidario: {}
    };

    public tipos_proveedor: any[] = [];
    public tipos_arrendatario: any[] = [];
    public loading_proveedor: boolean = false;
    public loading: boolean = false;
    public obra: any = {};
    public obras_emisoras: any = {};
    public obras: any[];
    public proveedor: any = {};
    public proveedor_busqueda_mensaje:string="";
    public tipo_arrendatario:any={};
    public persona:any={};
    public personas:any[]=[];

    public bcliente: any = [];

    
    //Modelos
    public apoderadoLegal = { es_apoderado_legal: 1};
    public obligadoSolidario = {};
    public usosCFDI: any[] = [];
    
    //Helpers
    public mostrarObligadoSolidario = false;
    public mostrarApoderadoLegal = false; 
    public obra_emisor: any = {};
    public mantenimiento_emisor: any = {};
    public servicios_emisor: any = {};
    public mostrarEmisoresPersonalizados: boolean = false;
    public usoCFDISeleccionado: any = {};
    
    constructor(private cuentasPorCobrarService: CuentasPorCobrarService,
      private catalogosSatService: CatalogosSatService) {
    }

    ngOnInit() {
      this.cargarClientes();
      this.loadObrasEmisoras();
      this.loadObras();
      this.cargarUsosCFDI();
      this.loadTiposProveedor();
      this.loadTiposArrendatario();
      this.loadTiposPersonas();
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.contrato && this.contrato) {
        this.configurarComponente();
      }
    }
    
    private configurarComponente(){
      let component = this;
      this.contrato.obligados_solidarios.forEach(obligadoSolidario => {
        if(obligadoSolidario.es_apoderado_legal){
          component.apoderadoLegal = obligadoSolidario;
        } else {
          component.obligadoSolidario = obligadoSolidario;
        }
      });      
    }
    private cargarClientes(){
      //define la carga de clientes 
       this.cuentasPorCobrarService.getProveedores2()
         .subscribe((response)=>{
           let content = response.json().content;  
        
           this.bcliente =content;

         });   
     }
    loadTiposPersonas(){
      this.personas.push({id:'fisica',descripcion:"Física"});
      this.personas.push({id:'moral',descripcion:"Moral"});
    }

    loadObrasEmisoras(){
      this.cuentasPorCobrarService.getObrasEmisoras()
        .subscribe((response) => {
          this.obras_emisoras = response.json().content;
        });
    }

    loadObras(){
      this.cuentasPorCobrarService.getObras()
        .subscribe((response) => {
          this.obras = response.json().content;
          /* for(var i=0;i<this.obras.length;i++){
            var obra = this.obras[i];
            if(obra.nombreHub){
              obra.nombreObraHub = obra.nombreObra + " - " + obra.nombreHub;
            }else{
              obra.nombreObraHub = obra.nombreObra;
            }
          } */
        });
    }

    loadTiposProveedor(){
      this.cuentasPorCobrarService.getTiposProveedores()
        .subscribe(response => {
          let content = response.json().content;
          this.tipos_proveedor = content;
        });
    }

    loadTiposArrendatario(){
      this.cuentasPorCobrarService.getTiposArrendatarios()
        .subscribe(response => {
          let content = response.json().content;
          this.tipos_arrendatario = content;
        });
    }

    buscarProveedor(rfc2){
      // RFC generico (publico en general): varios clientes comparten el mismo RFC,
      // por lo que NO se debe amarrar al cliente existente. Se manda directo al alta
      // de un cliente nuevo para poder tener varios contratos con el RFC generico.
      const rfcGenerico = (rfc2 || '').toString().trim().toUpperCase();
      const RFCS_GENERICOS = ['XAXX010101000', 'XEXX010101000'];
      if (RFCS_GENERICOS.indexOf(rfcGenerico) !== -1) {
        this.loading_proveedor = false;
        // Se OMITE id_proveedor (no se manda null): el backend valida id_proveedor
        // como entero y, al no venir, entra al alta de un proveedor nuevo.
        delete this.contrato.id_proveedor;
        this.contrato.proveedor = { rfc: rfcGenerico };
        this.apoderadoLegal = { es_apoderado_legal: 1 };
        this.obligadoSolidario = {};
        this.proveedor_busqueda_mensaje = "RFC genérico: da de alta el cliente nuevo a continuación.";
        this.proveedor_buscado = true;
        return;
      }
      this.loading_proveedor = true;
      this.cuentasPorCobrarService.buscarProveedorPorRFC(rfc2)
      .subscribe(response => {
          this.loading_proveedor = false;
          let content = response.json().content;
          this.proveedor_busqueda_mensaje = "";
          this.contrato.proveedor = content;
          this.contrato.id_proveedor = this.contrato.proveedor.idProveedores;
          console.log("this.contrato.id_proveedor: ",this.contrato.id_proveedor)
          this.setupArrendatarioData();
          this.proveedor_buscado = true;
          //Complementar OP Premier
          if(this.contrato.id_proveedor == 4187){
            this.cuentasPorCobrarService.providerInfo(this.contrato.id_proveedor)
            .subscribe(response => {
              let content = response.json().content;
              console.log("providerInfo content: ",content);
              const obligados_solidarios = content.obligados_solidarios;
              console.log("obligados_solidarios: ",obligados_solidarios.length);
              for(var i=0; i<obligados_solidarios.length; i++){
                var obligadoSolidario = obligados_solidarios[i];
                console.log("obligadoSolidario: ",obligadoSolidario);
                if(obligadoSolidario.es_apoderado_legal){
                  this.apoderadoLegal = obligadoSolidario;
                } else {
                  this.obligadoSolidario = obligadoSolidario;
                }
              }
            },
            error => {
              console.log("error: ",error);
              //if(error.status==404){
              //  this.proveedor_busqueda_mensaje = "Puedes dar de alta al arrendatario a continuación";
              //  this.proveedor_buscado = true;
              //}
            });
          }else{
            this.apoderadoLegal = { es_apoderado_legal: 1};
            this.obligadoSolidario = {};
          }
      },
      error => {
        this.loading_proveedor = false;
        if(error.status==404){
          this.proveedor_busqueda_mensaje = "Puedes dar de alta al arrendatario a continuación";
          this.proveedor_buscado = true;
        }
      });
    }
    public nuevaBusqueda(){
      this.proveedor_busqueda_mensaje = "";
      this.proveedor_buscado = false;
      this.contrato.proveedor={}
    }

    guardarContrato(go_to_next_page){
      //Agregar el apoderado legal y el olbigado solidario al modelo de contrato que se guardara
      this.agregarObligadosSolidariosAContrato();

      if(!this.validar()){
        return false;
      }

      this.loading = true;
      var parent = this;
      if(this.contratoGuardado){
        this.contratoGuardado.emit(
          {go_to_next_page:go_to_next_page,
            contrato:this.contrato, 
            callback: function(){
              parent.loading = false;
            }});
      }
    }

    public agregarObligadosSolidariosAContrato(){
      this.contrato.obligados_solidarios = [];
      
      if(this.mostrarApoderadoLegal){
        this.contrato.obligados_solidarios.push(this.apoderadoLegal);
      }
      if(this.mostrarObligadoSolidario){
        this.contrato.obligados_solidarios.push(this.obligadoSolidario);
      }      
    }

    public validar(){
      var valid = true;
      this.errors = [];
      this.errors = this.cuentasPorCobrarService.validarInfoContrato(this.contrato, this.tipo_arrendatario);
      if (!$.isEmptyObject(this.errors)) {
        valid = false;
      }
      return valid;
    }

    changeObraFilter($event){
      this.obra = $event;
      this.contrato.id_obra = this.obra.idObras;
    }

    changeObraEmisorFilter($event){
      this.obra_emisor = $event;
      this.contrato.id_emisor = this.obra_emisor.idObras;
    }

    changeMantenimientoEmisorFilter($event){
      this.mantenimiento_emisor = $event;
      this.contrato.id_emisor_mantenimiento = $event.idObras;
    }

    changeServiciosEmisorFilter($event){
      this.servicios_emisor = $event;
      this.contrato.id_emisor_servicios = $event.idObras;
    }

    changeTipoPersona($event){
      this.persona = $event;
      this.contrato.proveedor.tipo_persona = this.persona.id;
      this.configurarVistaPorTipoArrendatario();
    }

    changeTipoArrendatario($event){
      this.tipo_arrendatario = $event;
      this.contrato.proveedor.id_tipo_arrendatario = $event.id
      this.configurarVistaPorTipoArrendatario();
    }

    private configurarVistaPorTipoArrendatario(){
      if(this.contrato.proveedor.id_tipo_arrendatario === CuentasPorCobrarService.ARRENDATARIO_TIPO_MIEMBRO){
        this.mostrarObligadoSolidario = false;
      }else{
        //Arrendatario no miembro
        this.mostrarObligadoSolidario = true;
      }

      if(this.contrato.proveedor.tipo_persona && this.contrato.proveedor.tipo_persona.toLowerCase() ==='moral'){
        this.mostrarApoderadoLegal = true;
      }else{
        //Persona física  
        this.mostrarApoderadoLegal = false;
      }
    }

    loadContrato(){
      //Si se esta editando un contrato, se debe configurar los combos con los valores del contrato
      if(!this.contrato.id_contrato){
        return;
      }

      if(this.contrato.proveedor.idProveedores && this.contrato.proveedor.idProveedores!=0){
        this.proveedor_buscado = true;
      }

      for(var i=0;i<this.obras.length;i++){
          var obra = this.obras[i];
      }
        
      let component = this;
      if(this.contrato.id_emisor_mantenimiento || this.contrato.id_emisor_servicios){
        this.mostrarEmisoresPersonalizados = true;   
      }
        
      this.obras.forEach(obra => {
        
          //Seleccionar el inmueble del contrato
          if(obra.idObras == this.contrato.id_obra){
          this.obra = obra;
          }

          //Seleccionar el emisor general
          if(obra.idObras == this.contrato.id_emisor){
            this.obra_emisor = obra;
          }

          //Seleccionar el emisor del mantenimiento
          if( this.contrato.id_emisor_mantenimiento && obra.idObras == this.contrato.id_emisor_mantenimiento){
            component.mantenimiento_emisor = obra;
          }

          //Seleccionar el emisor de los servicios
          if( this.contrato.id_emisor_servicios && obra.idObras == this.contrato.id_emisor_servicios){
            component.servicios_emisor = obra;
          }

        });

      this.setupArrendatarioData();

      //Seleccionar en el combo el uso del CFDI del contrato
      let usoCFDIDefault = component.contrato.uso_cfdi ? component.contrato.uso_cfdi : CuentasPorCobrarService.USO_CFDI_DEFAULT;
      this.usosCFDI.some(usoDelCFDI => {
        if(usoDelCFDI.codigo === usoCFDIDefault){
          component.usoCFDISeleccionado = usoDelCFDI;
          return true;
        }
        return false;
      });
      
    }

    setupArrendatarioData(){
      //Reflejar el tipo de arrendatario en el dropdown
      for(var i=0;i<this.tipos_arrendatario.length;i++){
        var arr = this.tipos_arrendatario[i];
        if(arr.id_tipo_arrendatario==this.contrato.proveedor.id_tipo_arrendatario){
          this.tipo_arrendatario = arr;
        }
      }

      //Reflejar el tipo de persona en el dropdown
      for(var i=0;i<this.personas.length;i++){
        var p = this.personas[i];
        if(this.contrato.proveedor && this.contrato.proveedor.tipo_persona && p.id.toLowerCase() == this.contrato.proveedor.tipo_persona.toLowerCase()){
          this.persona = p;
        }
      }

      this.configurarVistaPorTipoArrendatario();
    }

    public cambiarMostrarEmisorMantenimiento(){
      if(!this.mostrarEmisoresPersonalizados){
        //Reiniciar el valor del emisor del mantenimiento
        this.mantenimiento_emisor = {};
        this.contrato.id_emisor_mantenimiento = null;
        this.servicios_emisor = {};
        this.contrato.id_emisor_servicios = null;
      }
    }

    private cargarUsosCFDI(){
      this.catalogosSatService.obtenerUsosCFDI().subscribe((response) => {
          let usosCFDI = response.json().content;

          //Seleccionar el uso default
          let component = this;
          usosCFDI.some(usoDelCFDI => {
            if(usoDelCFDI.codigo === CuentasPorCobrarService.USO_CFDI_DEFAULT){
              component.usoCFDISeleccionado = usoDelCFDI;
              component.contrato.uso_cfdi = usoDelCFDI.codigo;
              return true;
            }
            return false;
          });

          this.usosCFDI = usosCFDI;
      });
    }

    public seleccionarUsoCFDI($event){
      this.usoCFDISeleccionado = $event;
      this.contrato.uso_cfdi = $event.codigo;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/formulario-contrato/formulario-contrato.component.ts